// extracted by mini-css-extract-plugin
module.exports = {"container":"Faq_container__jzVA_","formWrapper":"Faq_formWrapper__NpVeG","sectionsContainer":"Faq_sectionsContainer__Q8GD3","link":"Faq_link__37g8P"};